import { get, post } from '@/api/request'
import { utilities } from '@billow/js-helpers'

export default {

  store: (user, success, failure) => post(
    '/api/user',
    user,
    response => success(response),
    error => failure(error)
  ),

  update: (user, success, failure) => post(
    `/api/user/${user.id}`,
    user,
    response => success(response),
    error => failure(error)
  ),

  loadList: (success, failure) => get(
    `/api/list/users`,
    response => success(response),
    error => failure(error)
  ),

  loadUser: (userId, success, failure) => get(
    `/api/user/${userId}`,
    response => success(response),
    error => failure(error)
  ),

  loadOverview: (userId, success, failure) => get(
    `/api/user/${userId}/overview`,
    response => success(response),
    error => failure(error)
  ),

  uploadProfilePicture: (payload, success, failure) => post(
    `/api/user/${payload.userId}/picture`,
    utilities.formData({ picture: payload.picture }),
    response => success(response),
    error => failure(error)
  ),

  loadUserOverview: (userId, success, failure) => get(
    `/api/user/${userId}/overview`,
    response => success(response),
    error => failure(error)
  ),

  allowAbility: ({ ability, user }, success, failure) => post(
    `/api/user/${user}/allow`,
    ability,
    success, failure
  ),

  disallowAbility: ({ ability, user }, success, failure) => post(
    `/api/user/${user}/disallow`,
    ability,
    success, failure
  ),

  disableUser: (userId, success, failure) => post(
    `/api/user/${userId}/disable`,
    {},
    success, failure
  ),

  reactivateUser: (userId, success, failure) => post(
    `/api/user/${userId}/reactivate`,
    {},
    success, failure
  ),
}
